export default __webpack_public_path__ + "images/taki-chat-text.svg";